<template>
  <div class="container">
    <div class="emptyContainer" v-if="empty !== ''">{{ empty }}</div>
    <div class="content" v-else v-html="content"></div>
  </div>
</template>

<script>
import { getArticleInfo } from "@/api/article";

export default {
  name: "index",
  data() {
    return {
      content: "",
      empty: "",
    };
  },
  created() {
    let id = this.$route.params.id;
    console.info("id = ", id);
    this.getArticle(id);
  },
  methods: {
    getArticle(id) {
      getArticleInfo({id}).then((res) => {
        let data = res.data;
        if (data.code === 0 && data.data) {
          this.content = data.data.content;

          const div = document.getElementById("title");
          let old = div.innerHTML;
          // div.innerHTML = old.split("-")[0] + "-" + data.data.title;
          div.innerHTML = data.data.title;
        } else {
          this.empty = "内容不存在";
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  height: 100vh;
  width: 100%;
}
.content {
  /* margin: 20px; */
}
.emptyContainer {
  display: flex;
  height: 100%;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  font-weight: 600;
}
</style>
